<template>
    <div id="app">
        <vue-progress-bar />
        <router-view/>
    </div>
</template>

<script>
    import "vue-select/src/scss/vue-select.scss";

    import '@/assets/sass/index.scss';

export default {

};
</script>
